var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraduationCap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1563_23990)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.4861 16.0294L25.7361 4.02941C25.4031 3.84557 25.029 3.74915 24.6486 3.74915C24.2682 3.74915 23.8941 3.84557 23.5611 4.02941L1.81111 16.0294C1.45944 16.224 1.1663 16.5092 0.962173 16.8554C0.758049 17.2017 0.650391 17.5962 0.650391 17.9982C0.650391 18.4001 0.758049 18.7947 0.962173 19.1409C1.1663 19.4871 1.45944 19.7723 1.81111 19.9669L5.89861 22.2169V31.1719C5.89713 32.0938 6.23713 32.9835 6.85299 33.6694C9.39174 36.5063 15.0861 41.25 24.6486 41.25C27.1882 41.2637 29.7157 40.9004 32.1486 40.1719V45C32.1486 45.5968 32.3857 46.1691 32.8076 46.591C33.2296 47.013 33.8019 47.25 34.3986 47.25C34.9953 47.25 35.5676 47.013 35.9896 46.591C36.4116 46.1691 36.6486 45.5968 36.6486 45V38.2725C38.8217 37.0722 40.7802 35.5192 42.4442 33.6769C43.0601 32.991 43.4001 32.1013 43.3986 31.1794V22.2244L47.4861 19.9744C47.8378 19.7798 48.1309 19.4946 48.3351 19.1484C48.5392 18.8022 48.6468 18.4076 48.6468 18.0057C48.6468 17.6037 48.5392 17.2092 48.3351 16.8629C48.1309 16.5167 47.8378 16.2315 47.4861 16.0369V16.0294ZM24.6486 8.57066L41.7411 18L35.5236 21.4313C35.5119 21.4244 35.5007 21.4169 35.4899 21.4088L25.7399 16.0294C25.2193 15.7604 24.6143 15.705 24.0536 15.8751C23.4929 16.0452 23.0206 16.4274 22.7373 16.9403C22.454 17.4532 22.3819 18.0564 22.5365 18.6217C22.691 19.1869 23.06 19.6695 23.5649 19.9669L30.8774 23.9963L24.6486 27.4313L7.55611 18L24.6486 8.57066ZM24.6486 36.75C17.0699 36.75 12.5267 33.1744 10.3986 30.8869V24.6994L23.5611 31.9632C23.8941 32.147 24.2682 32.2434 24.6486 32.2434C25.029 32.2434 25.4031 32.147 25.7361 31.9632L32.1486 28.4325V35.4132C29.7528 36.3187 27.2098 36.772 24.6486 36.75ZM38.8986 30.8869C38.2087 31.6264 37.4558 32.3045 36.6486 32.9138V25.9482L38.8986 24.7069V30.8869Z",
    fill: "url(#paint0_linear_1563_23990)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1563_23990",
    x1: 24.6486,
    y1: 3.74915,
    x2: 24.6486,
    y2: 47.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1563_23990"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.648438)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraduationCap);
export default __webpack_public_path__ + "static/media/GraduationCap.3f2ea16d380d9401064a8732a23daa1d.svg";
export { ForwardRef as ReactComponent };